export enum KnowledgeCardsIntentType {
	PERSON = 'PERSON',
	TEAM = 'TEAM',
	AGENT = 'AGENT',
	VISUAL = 'VISUAL',
}

export enum KnowledgeCardsRowType {
	PERSON = 'PERSON',
	WORK = 'WORK',
	AGENT = 'AGENT',
}
